// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/jobs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.jobs";

export interface DevJob {
  type: { $case: "taskImplementation"; value: TaskImplementationJob } | undefined;
}

export interface TaskImplementationJob {
  taskId: string;
}

export interface PrototypeWalkthroughJobDetails {
  prototypeUrl: string;
  userRequest: string;
  projectId?: string | undefined;
}

export interface QuickWinInitJobDetails {
  description: string;
  projectId?: string | undefined;
  documentId?: string | undefined;
}

export interface BugInitJobDetails {
  description: string;
  projectId?: string | undefined;
  documentId?: string | undefined;
}

export interface CatalogFeedbackJobDetails {
  draftId: string;
  comment: string;
  codeupJobId?: string | undefined;
  latestRunId?: string | undefined;
  cleanupError?: string | undefined;
}

/**
 * Background processing of artifacts attached at intake time:
 * per-attachment ingestion fan-out for files (re-linked from workspace-scoped
 * uploads to the new project) and for issue links materialized as Attachment
 * rows during project creation. Used by the "Create Projects" intake flow;
 * will be extended later for bulk / multi-project import.
 */
export interface ProjectIntakeJobDetails {
  projectId: string;
  documentId: string;
  attachmentIds: string[];
}

export interface AttachmentProcessingJobDetails {
  attachmentIds: string[];
}

export interface PendingJob {
  id: string;
  workspaceId: string;
  jobType: string;
  jobParentId: string;
  startedBy: string;
  details:
    | { $case: "prototypeWalkthrough"; value: PrototypeWalkthroughJobDetails }
    | { $case: "quickWinInit"; value: QuickWinInitJobDetails }
    | { $case: "bugInit"; value: BugInitJobDetails }
    | { $case: "catalogFeedback"; value: CatalogFeedbackJobDetails }
    | { $case: "projectIntake"; value: ProjectIntakeJobDetails }
    | { $case: "attachmentProcessing"; value: AttachmentProcessingJobDetails }
    | undefined;
  nextProcessAt: Date | undefined;
  status: string;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

function createBaseDevJob(): DevJob {
  return { type: undefined };
}

export const DevJob: MessageFns<DevJob> = {
  encode(message: DevJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.type?.$case) {
      case "taskImplementation":
        TaskImplementationJob.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "taskImplementation", value: TaskImplementationJob.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DevJob {
    return {
      type: isSet(object.taskImplementation)
        ? { $case: "taskImplementation", value: TaskImplementationJob.fromJSON(object.taskImplementation) }
        : isSet(object.task_implementation)
        ? { $case: "taskImplementation", value: TaskImplementationJob.fromJSON(object.task_implementation) }
        : undefined,
    };
  },

  toJSON(message: DevJob): unknown {
    const obj: any = {};
    if (message.type?.$case === "taskImplementation") {
      obj.taskImplementation = TaskImplementationJob.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<DevJob>): DevJob {
    return DevJob.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DevJob>): DevJob {
    const message = createBaseDevJob();
    switch (object.type?.$case) {
      case "taskImplementation": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "taskImplementation", value: TaskImplementationJob.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseTaskImplementationJob(): TaskImplementationJob {
  return { taskId: "" };
}

export const TaskImplementationJob: MessageFns<TaskImplementationJob> = {
  encode(message: TaskImplementationJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== "") {
      writer.uint32(10).string(message.taskId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskImplementationJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskImplementationJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskImplementationJob {
    return {
      taskId: isSet(object.taskId)
        ? globalThis.String(object.taskId)
        : isSet(object.task_id)
        ? globalThis.String(object.task_id)
        : "",
    };
  },

  toJSON(message: TaskImplementationJob): unknown {
    const obj: any = {};
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    return obj;
  },

  create(base?: DeepPartial<TaskImplementationJob>): TaskImplementationJob {
    return TaskImplementationJob.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TaskImplementationJob>): TaskImplementationJob {
    const message = createBaseTaskImplementationJob();
    message.taskId = object.taskId ?? "";
    return message;
  },
};

function createBasePrototypeWalkthroughJobDetails(): PrototypeWalkthroughJobDetails {
  return { prototypeUrl: "", userRequest: "", projectId: undefined };
}

export const PrototypeWalkthroughJobDetails: MessageFns<PrototypeWalkthroughJobDetails> = {
  encode(message: PrototypeWalkthroughJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prototypeUrl !== "") {
      writer.uint32(10).string(message.prototypeUrl);
    }
    if (message.userRequest !== "") {
      writer.uint32(18).string(message.userRequest);
    }
    if (message.projectId !== undefined) {
      writer.uint32(26).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrototypeWalkthroughJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrototypeWalkthroughJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prototypeUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userRequest = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrototypeWalkthroughJobDetails {
    return {
      prototypeUrl: isSet(object.prototypeUrl)
        ? globalThis.String(object.prototypeUrl)
        : isSet(object.prototype_url)
        ? globalThis.String(object.prototype_url)
        : "",
      userRequest: isSet(object.userRequest)
        ? globalThis.String(object.userRequest)
        : isSet(object.user_request)
        ? globalThis.String(object.user_request)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
    };
  },

  toJSON(message: PrototypeWalkthroughJobDetails): unknown {
    const obj: any = {};
    if (message.prototypeUrl !== "") {
      obj.prototypeUrl = message.prototypeUrl;
    }
    if (message.userRequest !== "") {
      obj.userRequest = message.userRequest;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<PrototypeWalkthroughJobDetails>): PrototypeWalkthroughJobDetails {
    return PrototypeWalkthroughJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PrototypeWalkthroughJobDetails>): PrototypeWalkthroughJobDetails {
    const message = createBasePrototypeWalkthroughJobDetails();
    message.prototypeUrl = object.prototypeUrl ?? "";
    message.userRequest = object.userRequest ?? "";
    message.projectId = object.projectId ?? undefined;
    return message;
  },
};

function createBaseQuickWinInitJobDetails(): QuickWinInitJobDetails {
  return { description: "", projectId: undefined, documentId: undefined };
}

export const QuickWinInitJobDetails: MessageFns<QuickWinInitJobDetails> = {
  encode(message: QuickWinInitJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    if (message.documentId !== undefined) {
      writer.uint32(26).string(message.documentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QuickWinInitJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickWinInitJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuickWinInitJobDetails {
    return {
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : undefined,
    };
  },

  toJSON(message: QuickWinInitJobDetails): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.documentId !== undefined) {
      obj.documentId = message.documentId;
    }
    return obj;
  },

  create(base?: DeepPartial<QuickWinInitJobDetails>): QuickWinInitJobDetails {
    return QuickWinInitJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<QuickWinInitJobDetails>): QuickWinInitJobDetails {
    const message = createBaseQuickWinInitJobDetails();
    message.description = object.description ?? "";
    message.projectId = object.projectId ?? undefined;
    message.documentId = object.documentId ?? undefined;
    return message;
  },
};

function createBaseBugInitJobDetails(): BugInitJobDetails {
  return { description: "", projectId: undefined, documentId: undefined };
}

export const BugInitJobDetails: MessageFns<BugInitJobDetails> = {
  encode(message: BugInitJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    if (message.documentId !== undefined) {
      writer.uint32(26).string(message.documentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BugInitJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBugInitJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BugInitJobDetails {
    return {
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : undefined,
    };
  },

  toJSON(message: BugInitJobDetails): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.documentId !== undefined) {
      obj.documentId = message.documentId;
    }
    return obj;
  },

  create(base?: DeepPartial<BugInitJobDetails>): BugInitJobDetails {
    return BugInitJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BugInitJobDetails>): BugInitJobDetails {
    const message = createBaseBugInitJobDetails();
    message.description = object.description ?? "";
    message.projectId = object.projectId ?? undefined;
    message.documentId = object.documentId ?? undefined;
    return message;
  },
};

function createBaseCatalogFeedbackJobDetails(): CatalogFeedbackJobDetails {
  return { draftId: "", comment: "", codeupJobId: undefined, latestRunId: undefined, cleanupError: undefined };
}

export const CatalogFeedbackJobDetails: MessageFns<CatalogFeedbackJobDetails> = {
  encode(message: CatalogFeedbackJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.draftId !== "") {
      writer.uint32(10).string(message.draftId);
    }
    if (message.comment !== "") {
      writer.uint32(18).string(message.comment);
    }
    if (message.codeupJobId !== undefined) {
      writer.uint32(26).string(message.codeupJobId);
    }
    if (message.latestRunId !== undefined) {
      writer.uint32(34).string(message.latestRunId);
    }
    if (message.cleanupError !== undefined) {
      writer.uint32(42).string(message.cleanupError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogFeedbackJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogFeedbackJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.draftId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.codeupJobId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.latestRunId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cleanupError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatalogFeedbackJobDetails {
    return {
      draftId: isSet(object.draftId)
        ? globalThis.String(object.draftId)
        : isSet(object.draft_id)
        ? globalThis.String(object.draft_id)
        : "",
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      codeupJobId: isSet(object.codeupJobId)
        ? globalThis.String(object.codeupJobId)
        : isSet(object.codeup_job_id)
        ? globalThis.String(object.codeup_job_id)
        : undefined,
      latestRunId: isSet(object.latestRunId)
        ? globalThis.String(object.latestRunId)
        : isSet(object.latest_run_id)
        ? globalThis.String(object.latest_run_id)
        : undefined,
      cleanupError: isSet(object.cleanupError)
        ? globalThis.String(object.cleanupError)
        : isSet(object.cleanup_error)
        ? globalThis.String(object.cleanup_error)
        : undefined,
    };
  },

  toJSON(message: CatalogFeedbackJobDetails): unknown {
    const obj: any = {};
    if (message.draftId !== "") {
      obj.draftId = message.draftId;
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.codeupJobId !== undefined) {
      obj.codeupJobId = message.codeupJobId;
    }
    if (message.latestRunId !== undefined) {
      obj.latestRunId = message.latestRunId;
    }
    if (message.cleanupError !== undefined) {
      obj.cleanupError = message.cleanupError;
    }
    return obj;
  },

  create(base?: DeepPartial<CatalogFeedbackJobDetails>): CatalogFeedbackJobDetails {
    return CatalogFeedbackJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatalogFeedbackJobDetails>): CatalogFeedbackJobDetails {
    const message = createBaseCatalogFeedbackJobDetails();
    message.draftId = object.draftId ?? "";
    message.comment = object.comment ?? "";
    message.codeupJobId = object.codeupJobId ?? undefined;
    message.latestRunId = object.latestRunId ?? undefined;
    message.cleanupError = object.cleanupError ?? undefined;
    return message;
  },
};

function createBaseProjectIntakeJobDetails(): ProjectIntakeJobDetails {
  return { projectId: "", documentId: "", attachmentIds: [] };
}

export const ProjectIntakeJobDetails: MessageFns<ProjectIntakeJobDetails> = {
  encode(message: ProjectIntakeJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectId !== "") {
      writer.uint32(10).string(message.projectId);
    }
    if (message.documentId !== "") {
      writer.uint32(18).string(message.documentId);
    }
    for (const v of message.attachmentIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectIntakeJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectIntakeJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectIntakeJobDetails {
    return {
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : "",
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProjectIntakeJobDetails): unknown {
    const obj: any = {};
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.documentId !== "") {
      obj.documentId = message.documentId;
    }
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectIntakeJobDetails>): ProjectIntakeJobDetails {
    return ProjectIntakeJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectIntakeJobDetails>): ProjectIntakeJobDetails {
    const message = createBaseProjectIntakeJobDetails();
    message.projectId = object.projectId ?? "";
    message.documentId = object.documentId ?? "";
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseAttachmentProcessingJobDetails(): AttachmentProcessingJobDetails {
  return { attachmentIds: [] };
}

export const AttachmentProcessingJobDetails: MessageFns<AttachmentProcessingJobDetails> = {
  encode(message: AttachmentProcessingJobDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachmentIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentProcessingJobDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentProcessingJobDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentProcessingJobDetails {
    return {
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AttachmentProcessingJobDetails): unknown {
    const obj: any = {};
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentProcessingJobDetails>): AttachmentProcessingJobDetails {
    return AttachmentProcessingJobDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentProcessingJobDetails>): AttachmentProcessingJobDetails {
    const message = createBaseAttachmentProcessingJobDetails();
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    return message;
  },
};

function createBasePendingJob(): PendingJob {
  return {
    id: "",
    workspaceId: "",
    jobType: "",
    jobParentId: "",
    startedBy: "",
    details: undefined,
    nextProcessAt: undefined,
    status: "",
    createdAt: undefined,
    updatedAt: undefined,
  };
}

export const PendingJob: MessageFns<PendingJob> = {
  encode(message: PendingJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.workspaceId !== "") {
      writer.uint32(18).string(message.workspaceId);
    }
    if (message.jobType !== "") {
      writer.uint32(26).string(message.jobType);
    }
    if (message.jobParentId !== "") {
      writer.uint32(34).string(message.jobParentId);
    }
    if (message.startedBy !== "") {
      writer.uint32(42).string(message.startedBy);
    }
    switch (message.details?.$case) {
      case "prototypeWalkthrough":
        PrototypeWalkthroughJobDetails.encode(message.details.value, writer.uint32(802).fork()).join();
        break;
      case "quickWinInit":
        QuickWinInitJobDetails.encode(message.details.value, writer.uint32(810).fork()).join();
        break;
      case "bugInit":
        BugInitJobDetails.encode(message.details.value, writer.uint32(818).fork()).join();
        break;
      case "catalogFeedback":
        CatalogFeedbackJobDetails.encode(message.details.value, writer.uint32(826).fork()).join();
        break;
      case "projectIntake":
        ProjectIntakeJobDetails.encode(message.details.value, writer.uint32(834).fork()).join();
        break;
      case "attachmentProcessing":
        AttachmentProcessingJobDetails.encode(message.details.value, writer.uint32(842).fork()).join();
        break;
    }
    if (message.nextProcessAt !== undefined) {
      Timestamp.encode(toTimestamp(message.nextProcessAt), writer.uint32(58).fork()).join();
    }
    if (message.status !== "") {
      writer.uint32(66).string(message.status);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PendingJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePendingJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workspaceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.jobType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.jobParentId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.startedBy = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.details = {
            $case: "prototypeWalkthrough",
            value: PrototypeWalkthroughJobDetails.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.details = { $case: "quickWinInit", value: QuickWinInitJobDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.details = { $case: "bugInit", value: BugInitJobDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.details = {
            $case: "catalogFeedback",
            value: CatalogFeedbackJobDetails.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.details = { $case: "projectIntake", value: ProjectIntakeJobDetails.decode(reader, reader.uint32()) };
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.details = {
            $case: "attachmentProcessing",
            value: AttachmentProcessingJobDetails.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nextProcessAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PendingJob {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      workspaceId: isSet(object.workspaceId)
        ? globalThis.String(object.workspaceId)
        : isSet(object.workspace_id)
        ? globalThis.String(object.workspace_id)
        : "",
      jobType: isSet(object.jobType)
        ? globalThis.String(object.jobType)
        : isSet(object.job_type)
        ? globalThis.String(object.job_type)
        : "",
      jobParentId: isSet(object.jobParentId)
        ? globalThis.String(object.jobParentId)
        : isSet(object.job_parent_id)
        ? globalThis.String(object.job_parent_id)
        : "",
      startedBy: isSet(object.startedBy)
        ? globalThis.String(object.startedBy)
        : isSet(object.started_by)
        ? globalThis.String(object.started_by)
        : "",
      details: isSet(object.prototypeWalkthrough)
        ? { $case: "prototypeWalkthrough", value: PrototypeWalkthroughJobDetails.fromJSON(object.prototypeWalkthrough) }
        : isSet(object.prototype_walkthrough)
        ? {
          $case: "prototypeWalkthrough",
          value: PrototypeWalkthroughJobDetails.fromJSON(object.prototype_walkthrough),
        }
        : isSet(object.quickWinInit)
        ? { $case: "quickWinInit", value: QuickWinInitJobDetails.fromJSON(object.quickWinInit) }
        : isSet(object.quick_win_init)
        ? { $case: "quickWinInit", value: QuickWinInitJobDetails.fromJSON(object.quick_win_init) }
        : isSet(object.bugInit)
        ? { $case: "bugInit", value: BugInitJobDetails.fromJSON(object.bugInit) }
        : isSet(object.bug_init)
        ? { $case: "bugInit", value: BugInitJobDetails.fromJSON(object.bug_init) }
        : isSet(object.catalogFeedback)
        ? { $case: "catalogFeedback", value: CatalogFeedbackJobDetails.fromJSON(object.catalogFeedback) }
        : isSet(object.catalog_feedback)
        ? { $case: "catalogFeedback", value: CatalogFeedbackJobDetails.fromJSON(object.catalog_feedback) }
        : isSet(object.projectIntake)
        ? { $case: "projectIntake", value: ProjectIntakeJobDetails.fromJSON(object.projectIntake) }
        : isSet(object.project_intake)
        ? { $case: "projectIntake", value: ProjectIntakeJobDetails.fromJSON(object.project_intake) }
        : isSet(object.attachmentProcessing)
        ? { $case: "attachmentProcessing", value: AttachmentProcessingJobDetails.fromJSON(object.attachmentProcessing) }
        : isSet(object.attachment_processing)
        ? {
          $case: "attachmentProcessing",
          value: AttachmentProcessingJobDetails.fromJSON(object.attachment_processing),
        }
        : undefined,
      nextProcessAt: isSet(object.nextProcessAt)
        ? fromJsonTimestamp(object.nextProcessAt)
        : isSet(object.next_process_at)
        ? fromJsonTimestamp(object.next_process_at)
        : undefined,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: PendingJob): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.workspaceId !== "") {
      obj.workspaceId = message.workspaceId;
    }
    if (message.jobType !== "") {
      obj.jobType = message.jobType;
    }
    if (message.jobParentId !== "") {
      obj.jobParentId = message.jobParentId;
    }
    if (message.startedBy !== "") {
      obj.startedBy = message.startedBy;
    }
    if (message.details?.$case === "prototypeWalkthrough") {
      obj.prototypeWalkthrough = PrototypeWalkthroughJobDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "quickWinInit") {
      obj.quickWinInit = QuickWinInitJobDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "bugInit") {
      obj.bugInit = BugInitJobDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "catalogFeedback") {
      obj.catalogFeedback = CatalogFeedbackJobDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "projectIntake") {
      obj.projectIntake = ProjectIntakeJobDetails.toJSON(message.details.value);
    } else if (message.details?.$case === "attachmentProcessing") {
      obj.attachmentProcessing = AttachmentProcessingJobDetails.toJSON(message.details.value);
    }
    if (message.nextProcessAt !== undefined) {
      obj.nextProcessAt = message.nextProcessAt.toISOString();
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<PendingJob>): PendingJob {
    return PendingJob.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PendingJob>): PendingJob {
    const message = createBasePendingJob();
    message.id = object.id ?? "";
    message.workspaceId = object.workspaceId ?? "";
    message.jobType = object.jobType ?? "";
    message.jobParentId = object.jobParentId ?? "";
    message.startedBy = object.startedBy ?? "";
    switch (object.details?.$case) {
      case "prototypeWalkthrough": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = {
            $case: "prototypeWalkthrough",
            value: PrototypeWalkthroughJobDetails.fromPartial(object.details.value),
          };
        }
        break;
      }
      case "quickWinInit": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = { $case: "quickWinInit", value: QuickWinInitJobDetails.fromPartial(object.details.value) };
        }
        break;
      }
      case "bugInit": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = { $case: "bugInit", value: BugInitJobDetails.fromPartial(object.details.value) };
        }
        break;
      }
      case "catalogFeedback": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = {
            $case: "catalogFeedback",
            value: CatalogFeedbackJobDetails.fromPartial(object.details.value),
          };
        }
        break;
      }
      case "projectIntake": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = {
            $case: "projectIntake",
            value: ProjectIntakeJobDetails.fromPartial(object.details.value),
          };
        }
        break;
      }
      case "attachmentProcessing": {
        if (object.details?.value !== undefined && object.details?.value !== null) {
          message.details = {
            $case: "attachmentProcessing",
            value: AttachmentProcessingJobDetails.fromPartial(object.details.value),
          };
        }
        break;
      }
    }
    message.nextProcessAt = object.nextProcessAt ?? undefined;
    message.status = object.status ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
